export default {"src":"/_next/static/media/0xc00e94cb662c3520282e6f5717214004a7f26888.009a6a55.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};